import { listarAvisos, marcarAvisoLido, marcarAvisosLidos } from '@infosaas/shared'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../shared/lib/supabase'

const CHAVE = ['portal-avisos']
const UM_MINUTO = 1000 * 60

/**
 * ADR-084 — o sino do cliente.
 *
 * Até aqui o portal não avisava nada: o cliente relatava, a equipe decidia, e
 * ele só descobria voltando à tela por conta própria. A tabela é nova
 * (`portal.notifications`) e a RLS já limita cada pessoa às linhas dela, então
 * a consulta aqui não filtra por ninguém.
 *
 * Como toda leitura nova do portal, degrada em vez de quebrar: ambiente sem a
 * migration devolve lista vazia e o sino simplesmente não aparece.
 */
export function useAvisos() {
  return useQuery({
    queryKey: CHAVE,
    queryFn: () => listarAvisos(supabase),
    staleTime: UM_MINUTO,
    // o cliente costuma deixar o portal aberto numa aba; sem isto ele veria a
    // resposta da equipe só no próximo F5
    refetchInterval: UM_MINUTO * 2,
    retry: false,
  })
}

export function useNaoLidos() {
  const { data } = useAvisos()
  return (data ?? []).filter((a) => !a.read).length
}

export function useMarcarAvisoLido() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id) => marcarAvisoLido(supabase, id),
    onSuccess: () => qc.invalidateQueries({ queryKey: CHAVE }),
  })
}

export function useMarcarTodosLidos() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => marcarAvisosLidos(supabase),
    onSuccess: () => qc.invalidateQueries({ queryKey: CHAVE }),
  })
}
